let settingsFetchController = null;

async function getMeThemSettings() {
  const API_ENDPOINT = 'https://fj-diamonds.myshopify.com/api/2023-10/graphql.json';
  const STOREFRONT_ACCESS_TOKEN = '252651bd258dc37dc6d04bdafc4d98ff';

  const params = new URLSearchParams(window.location.search);
  let filterData = {
    metal: params.get('metal') || '18k White Gold',
    shape: params.get('diamond_shape') || 'Round',
    style: params.get('style') || 'Solitaire',
    sort: params.get('sort_by') || 'COLLECTION_DEFAULT',
  };
  filterData.shape = filterData.shape
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  const isReverseSort = filterData.sort[0] === '-';

  const gqlquery = `
    query {
      collection(handle: "ring-builder-set") {
        handle
        products(
          first: 250
          sortKey: ${isReverseSort ? filterData.sort.slice(1) : filterData.sort}
          reverse: ${isReverseSort}
          filters: [
              { productMetafield: { namespace: "custom", key: "metal", value: "${filterData.metal}" } }
              { productMetafield: { namespace: "custom", key: "shape", value: "${filterData.shape}" } }
              { productMetafield: { namespace: "custom", key: "style", value: "${filterData.style}" } }
          ]
        ) {
          edges {
            node {
              handle
              id
              title
              description
              metal: metafield(namespace: "custom", key: "metal") {
                  value
              }
              shape: metafield(namespace: "custom", key: "shape") {
                  value
              }
              style: metafield(namespace: "custom", key: "style") {
                  value
              }
              width: metafield(namespace: "custom", key: "width") {
                  value
              }
              length: metafield(namespace: "custom", key: "length") {
                  value
              }
              v360Link: metafield(namespace: "custom", key: "v360_link") {
                value
              }
              v360FrameCount: metafield(namespace: "custom", key: "v360_frame_count") {
                value
              }
              images(first: 4) {
                edges {
                  node {
                      url
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    id
                    sku
                  }
                }
              }
              priceRange {
                minVariantPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }`;

  const requestConfig = {
    method: 'POST',
    headers: {
      'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: gqlquery,
      variables: {},
    }),
  };

  const productsGrid = document.querySelector('.products-grid');

  settingsFetchController?.abort();
  settingsFetchController = new AbortController();

  try {
    if (productsGrid) {
      productsGrid.classList.add('is-loading');
    }

    const response = await fetch(API_ENDPOINT, {
      ...requestConfig,
      signal: settingsFetchController.signal,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const responseBody = await response.json();

    if (filterData?.sort === 'TITLE') {
      const edges = responseBody.data.collection.products.edges;
      const abigailIndex = edges.findIndex((e) => e.node.title === 'Abigail');
      if (abigailIndex === 0) {
        const [abigail] = edges.splice(abigailIndex, 1);
        edges.splice(1, 0, abigail);
      }
    }

    localStorage.setItem('ringSettingProducts', JSON.stringify(responseBody));
    updateProductGrid(responseBody);
    runCurrencyConverter();

    return responseBody;
  } catch (error) {
    if (error.name === 'AbortError') return;
    console.error('Error fetching ring settings:', error);
    if (productsGrid) {
      productsGrid.classList.remove('is-loading');
      productsGrid.innerHTML = '<p class="products-grid__empty">No settings found</p>';
    }
  }
}

function updateProductGrid(responseBody) {
  const productsGrid = document.querySelector('.products-grid');
  if (!productsGrid) return;

  productsGrid.classList.remove('is-loading');
  productsGrid.innerHTML = '';

  const productCount = responseBody.data.collection.products.edges.length;
  const productCountHeader = document.querySelector('.showing-count-header');
  if (productCountHeader) {
    productCountHeader.innerHTML = `Showing <span>${productCount}</span> Settings`;
  }

  responseBody.data.collection.products.edges.forEach((product, index) => {
    const priceRanges = product.node.priceRange.minVariantPrice;

    const productCard = createProductCard(product.node, priceRanges.amount, index === 0);
    productsGrid.insertAdjacentHTML('beforeend', productCard);
    animateProductCard(productsGrid.lastElementChild);

    if (index === 0) {
      updateSettingMediaSlider(product.node.id, true);
    }
  });
}

function createProductCard(product, price, isFirst = false) {
  const firstImageUrl = withShopifyCdnWidth(product.images.edges[0]?.node.url, 300);
  const secondImageUrl = withShopifyCdnWidth(product.images.edges[1]?.node.url, 300) || firstImageUrl;
  // First card is above the fold / LCP candidate — don't lazy-load its primary image.
  const primaryLoading = isFirst
    ? 'loading="eager" fetchpriority="high"'
    : 'loading="lazy"';

  return `
        <div class="product-card"
             data-price="${product.priceRange.minVariantPrice.amount}"
             data-currency="${product.priceRange.minVariantPrice.currencyCode}"
             data-product-id="${product.id}"
             onclick="updateSettingMediaSlider('${product.id}')"
             style="opacity: 0">
            <div class="product-image">
                <img ${primaryLoading} decoding="async" src="${firstImageUrl || ''}" alt="${product.title}">
                <img loading="lazy" decoding="async" src="${secondImageUrl || ''}" alt="${product.title}">
            </div>
            <div class="product-name">${product.title}</div>
            <div class="product-price price-holder-value" data-price="${price}">${price}</div>
            <span class="setting-price-chip-tag">Ring Only</span>
        </div>
    `;
}

function animateProductCard(card) {
  requestAnimationFrame(() => {
    card.style.transition = 'opacity 0.5s ease-in';
    card.style.opacity = '1';
  });
}

function loadSettingsIfNeeded() {
  const hasLoadedProducts = document.querySelector('.products-grid .product-card:not(.skeleton)');
  if (!hasLoadedProducts) {
    getMeThemSettings();
  }
}

function automaticUpdateSettingFilters() {
  const urlParams = new URLSearchParams(window.location.search);
  const urlShape = urlParams.get('diamond_shape');
  const urlMetal = urlParams.get('metal');
  const urlStyle = urlParams.get('style');
  const isMobileWindow = window.matchMedia('(max-width: 768px)').matches;

  if (urlShape) {
    document
      .getElementById(isMobileWindow ? 'settingShapeOptions-mobile' : 'settingShapeOptions')
      ?.querySelectorAll('.option-item')
      .forEach((item) => {
        item.classList.toggle('active', urlShape === item.getAttribute('value'));
      });
  }

  if (urlStyle) {
    document
      .getElementById(isMobileWindow ? 'settingStyleOptions-mobile' : 'settingStyleOptions')
      ?.querySelectorAll('.option-item')
      .forEach((item) => {
        item.classList.toggle('active', urlStyle === item.getAttribute('value'));
      });
  }

  if (urlMetal) {
    document
      .getElementById(isMobileWindow ? 'settingMetalOptions-mobile' : 'settingMetalOptions')
      ?.querySelectorAll('.option-item')
      .forEach((item) => {
        item.classList.toggle('active', urlMetal === item.getAttribute('value'));
      });
  }
}

async function handleSettingFilterChange() {
  const sortActive = document.querySelector('#sortSheet .sort-option.active');
  const desktopSortOptions = document.getElementById('sortSheet--desktop');

  let selectedShapeFilter = 'Round';
  if (window.matchMedia('(max-width: 768px)').matches) {
    selectedShapeFilter = document
      .querySelector('#settingShapeOptions-mobile .option-item.active span')
      ?.textContent.trim();
  } else {
    selectedShapeFilter = document.querySelector('#settingShapeOptions .option-item.active span')?.textContent.trim();
  }

  const sortValue = sortActive?.getAttribute('data-sort-value') || desktopSortOptions.value;
  const isReverse =
    sortActive?.getAttribute('data-sort-reverse') === 'true' ||
    desktopSortOptions[desktopSortOptions.selectedIndex].getAttribute('data-sort-reverse') === 'true';

  const filterData = {
    metal:
      document.querySelector('.options-grid[data-grid-type="metal"] .option-item.active span')?.textContent.trim() ||
      '18k White Gold',
    shape: selectedShapeFilter || 'Round',
    style:
      document.querySelector('.options-grid[data-grid-type="style"] .option-item.active span')?.textContent.trim() ||
      'Solitaire',
    sort: sortValue,
  };

  const shape = filterData.shape.toUpperCase();
  const metal = filterData.metal;
  const style = filterData.style;
  const sortBy = (isReverse ? '-' : '') + filterData.sort;

  const urlParams = new URLSearchParams(window.location.search);
  const urlShape = urlParams.get('diamond_shape') || 'ROUND';
  const urlMetal = urlParams.get('metal') || '18k White Gold';
  const urlStyle = urlParams.get('style') || 'Solitaire';
  const urlSortBy = urlParams.get('sort_by') || 'COLLECTION_DEFAULT';

  if (urlShape !== shape) {
    createUrlFilterParams('diamond_shape', shape, shape !== 'ROUND', true, true);
  }
  if (urlMetal !== metal) {
    createUrlFilterParams('metal', metal, metal !== '18k White Gold', false, true);
  }
  if (urlStyle !== style) {
    createUrlFilterParams('style', style, style !== 'Solitaire', false, true);
  }
  if (urlSortBy !== sortBy) {
    createUrlFilterParams('sort_by', sortBy, sortBy !== 'COLLECTION_DEFAULT', false, true);
  }
}

function getRingSettingProduct(productId) {
  try {
    const saved = JSON.parse(localStorage.getItem('ringSettingProducts') || 'null');
    return (
      saved?.data?.collection?.products?.edges?.find((edge) => edge.node.id === productId)?.node ?? null
    );
  } catch {
    return null;
  }
}

function getV360FirstFrameUrl(baseUrl) {
  if (!baseUrl) return '';
  if (baseUrl.startsWith('https://cdn.shopify.com/s/files/1/0842/8965/0991/files/v360_Carla-Ecushion-cut')) {
    return `${baseUrl}00000.webp`;
  }
  if (baseUrl.startsWith('https://cdn.shopify.com/s/files/1/0842/8965/0991/files/v360_DS_')) {
    return `${baseUrl}_00000.webp`;
  }
  return `${baseUrl}-1.webp`;
}

function formatRingWidth(widthValue) {
  if (!widthValue) return '2.3mm';
  const width = String(widthValue).trim();
  return width.endsWith('mm') ? width : `${width} mm`;
}

// The 4th setting image (the model/on-hand shot) supports click-to-zoom.
const SETTING_ZOOMABLE_SLIDE_INDEX = 3;
const SETTING_SLIDE_ZOOM_SCALE = 1.5;
// The model shots are 2000x2000 masters and Shopify never upscales past the
// master, so asking for more than this only makes the URL longer.
const SETTING_ZOOM_MAX_IMAGE_WIDTH = 2000;

// Source pixels needed to stay sharp at full zoom on this particular screen:
// the slider's CSS width x the zoom factor x the device pixel ratio. Slider
// widths come from --slider-width in rb-setting-media-slider-360.
function getSettingZoomImageWidth() {
  const sliderCssWidth = window.matchMedia('(max-width: 1024px)').matches ? 350 : 540;
  const pixelRatio = Math.max(window.devicePixelRatio || 1, 1);
  return Math.min(
    Math.ceil(sliderCssWidth * SETTING_SLIDE_ZOOM_SCALE * pixelRatio),
    SETTING_ZOOM_MAX_IMAGE_WIDTH,
  );
}

function createSettingImageSlide(url, alt, width = 1080, isLcp = false, isZoomable = false) {
  const img = document.createElement('img');

  img.src = withShopifyCdnWidth(url, isZoomable ? getSettingZoomImageWidth() : width);
  img.alt = alt;
  img.className = 'slide slide-element';
  // Do NOT set loading="lazy" on slider slides — media-slider-360 waits for
  // every slide's onload before init, and lazy images off-screen may never fire.
  if (isLcp) {
    img.loading = 'eager';
    img.fetchPriority = 'high';
  }
  if (isZoomable) {
    img.setAttribute('data-zoomable', '');
  }
  return img;
}

function createSetting360Slide(product, firstImageUrl) {
  const v360Link = product.v360Link?.value;
  const frameCount = parseInt(product.v360FrameCount?.value, 10);
  if (!v360Link || !frameCount) return null;

  const viewer360Div = document.createElement('div');
  viewer360Div.className = 'slide slide-element';
  viewer360Div.setAttribute('data-v360-url', v360Link);
  viewer360Div.setAttribute('data-frame-count', String(frameCount));
  viewer360Div.setAttribute('data-top-img', firstImageUrl || getV360FirstFrameUrl(v360Link));
  return viewer360Div;
}

function buildSettingMediaSlides(product) {
  const slides = [];
  const firstImageUrl = product.images?.edges?.[0]?.node?.url;

  let slideImgwidth = window.matchMedia('(max-width: 1024px)').matches ? 700 : 1080;

  product.images?.edges?.forEach((image, index) => {
    // First product image is the slider's LCP candidate (main visible slide).
    // The 4th image is the on-hand model shot — it gets click-to-zoom.
    slides.push(
      createSettingImageSlide(
        image.node.url,
        product.title,
        slideImgwidth,
        index === 0,
        index === SETTING_ZOOMABLE_SLIDE_INDEX,
      ),
    );
  });

  const viewer360Slide = createSetting360Slide(product, firstImageUrl);
  if (viewer360Slide) slides.push(viewer360Slide);

  const packagingImageUrl = document.getElementById('360-slider-container')?.dataset.packagingImage;
  if (packagingImageUrl) {
    slides.push(createSettingImageSlide(packagingImageUrl, 'Packaging', slideImgwidth));
  }

  return slides;
}

function renderSettingProductSpecs(product) {
  const productDetails = document.querySelector('.product-gallery .product-details');
  if (!productDetails) return;

  const specs = [
    ['Metal', product.metal?.value || '18k White Gold'],
    ['Shape', product.shape?.value || 'Round'],
    ['Style', product.style?.value || 'Solitaire'],
    ['Ring Width', formatRingWidth(product.width?.value)],
  ];

  const grid = document.createElement('div');
  grid.className = 'setting-product-specs';

  specs.forEach(([label, value]) => {
    const row = document.createElement('div');
    const labelEl = document.createElement('span');
    labelEl.textContent = `${label}:`;
    row.appendChild(labelEl);
    row.append(` ${value}`);
    grid.appendChild(row);
  });

  productDetails.replaceChildren(grid);
}

function setActiveSettingProductCard(productId) {
  document.querySelectorAll('.product-card.active').forEach((card) => {
    card.classList.remove('active');
  });

  const productCard = document.querySelector(`[data-product-id="${productId}"]`);
  productCard?.classList.add('active');
}

function updateSettingMediaSlider(productId, skipIfSameProduct = false) {
  if (!productId) return;

  const product = getRingSettingProduct(productId);
  if (!product) return;

  localStorage.setItem('ringSettingProductSelected', JSON.stringify(product));

  if (typeof updateSettingProductInfo === 'function') {
    updateSettingProductInfo(product);
  }

  setActiveSettingProductCard(productId);

  if (typeof runCurrencyConverter === 'function') {
    runCurrencyConverter();
  }

  const sliderContainer = document.getElementById('360-slider-container');
  const mediaSlider = sliderContainer?.querySelector('media-slider-360');
  if (!mediaSlider) return;

  if (skipIfSameProduct && mediaSlider.getAttribute('product-id') === productId) {
    return;
  }

  mediaSlider.innerHTML = '';
  mediaSlider.setAttribute('slider-title', product.title);
  mediaSlider.setAttribute('product-id', productId);
  mediaSlider.append(...buildSettingMediaSlides(product));

  renderSettingProductSpecs(product);
}

let wasSettingSliderBelow1024 = window.matchMedia('(max-width: 1024px)').matches;

function reinitSettingMediaSliderOnBreakpointChange() {
  const isBelow1024 = window.matchMedia('(max-width: 1024px)').matches;
  if (isBelow1024 === wasSettingSliderBelow1024) return;

  wasSettingSliderBelow1024 = isBelow1024;

  try {
    const selectedProduct = JSON.parse(localStorage.getItem('ringSettingProductSelected') || 'null');
    if (selectedProduct?.id) {
      updateSettingMediaSlider(selectedProduct.id);
    }
  } catch (error) {
    console.error('Error reinitializing setting media slider on resize:', error);
  }
}

function initRingBuilderSetting() {
  const sortSheet = document.getElementById('sortSheet');
  const desktopSortOptions = document.getElementById('sortSheet--desktop');
  if (!sortSheet || !desktopSortOptions) return;

  const mobileSortOptions = sortSheet.querySelectorAll('.sort-option');

  document.querySelectorAll('.ring-builder-setting--wrapper .option-item').forEach((item) => {
    item.addEventListener('click', () => {
      const optionGrid = item.closest('.options-grid');
      const gridType = optionGrid.dataset.gridType;
      const allGrids = document.querySelectorAll(`.options-grid[data-grid-type="${gridType}"]`);

      allGrids.forEach((grid) => {
        grid.querySelectorAll('.option-item').forEach((gridItem) => {
          gridItem.classList.remove('active');
        });
      });

      const itemText = item.querySelector('span').textContent.trim();
      allGrids.forEach((grid) => {
        grid.querySelectorAll('.option-item').forEach((gridItem) => {
          if (gridItem.querySelector('span').textContent.trim() === itemText) {
            gridItem.classList.add('active');
          }
        });
      });

      handleSettingFilterChange();
    });
  });

  mobileSortOptions.forEach((option) => {
    option.addEventListener('click', () => {
      mobileSortOptions.forEach((opt) => opt.classList.remove('active'));
      option.classList.toggle('active');
      desktopSortOptions.value = option.getAttribute('data-sort-value');
      closeAllSheets();
      handleSettingFilterChange();
    });
  });

  desktopSortOptions.addEventListener('change', (e) => {
    const selectedOption = e.target.selectedOptions[0];
    const sortValue = selectedOption.value;
    const sortReverse = selectedOption.getAttribute('data-sort-reverse');

    mobileSortOptions.forEach((option) => {
      option.classList.remove('active');
      if (
        option.getAttribute('data-sort-value') === sortValue &&
        option.getAttribute('data-sort-reverse') === sortReverse
      ) {
        option.classList.add('active');
      }
    });
    handleSettingFilterChange();
  });
}

window.addEventListener('resize', reinitSettingMediaSliderOnBreakpointChange, { passive: true });

window.getMeThemSettings = getMeThemSettings;
window.automaticUpdateSettingFilters = automaticUpdateSettingFilters;
window.loadSettingsIfNeeded = loadSettingsIfNeeded;
window.updateSettingMediaSlider = updateSettingMediaSlider;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRingBuilderSetting);
} else {
  initRingBuilderSetting();
}

automaticUpdateSettingFilters();
loadSettingsIfNeeded();
